














































































































import {Vue,Component,Prop, Watch,Mixins} from 'vue-property-decorator';
import StringBookmark from './BookmarkComponents/StringBookmark.vue';
import EnterpriseFormContainer from './EnterpriseFormContainer/EnterpriseFormContainer.vue';
import {EnterpriseForm} from '@/store/models/EnterpriseForm/EnterpriseForm';
import RecipientLookup from '@/components/Cartable/ForwardLetter/RecipientLookup/RecipientLookup.vue';
import { LetterOwnerWithFaxAndEmails } from '@/store/models/LetterOwner/LetterOwnerWithFaxAndEmails';
import * as enterpriseFormService from '@/store/Services/enterpriseFormService';
import * as letterOwnerService from '@/store/Services/letterOwnerService';
import  FastSendRecipientSelector from '@/components/Cartable/FastSend/FastSendRecipientSelector/FastSendRecipientSelector.vue';
import store from '@/store';
import * as $ from 'jquery';
import ComponentMixinBase from '@/components/Cartable/ComponentMixins/ComponentMixinBase';
import { LetterOwnerForSendingFaxAndEmailAndSms } from '@/store/models/LetterOwner/LetterOwnerForSendingFaxAndEmailAndSms';
import InPlaceMessageBox  from '@/components/UiComponents/InPlaceMessageBox.vue';
import FullPageLoader from '@/components/UiComponents/FullPageLoader.vue';
import { NextFormInfo } from '@/store/models/EnterpriseForm/NextFormInfo';
import { DraftEnterpriseFormInfo } from '@/store/models/EnterpriseForm/LoadEnterpriseFormDraftResponse';
import * as fileService from '@/store/Services/fileService';
import * as util from '@/util/utils.ts';
import { Letter } from '@/store/models/Letter/Letter';
import  AnnouncementBoardSelector from '@/components/Cartable/AnnouncementBoardSelector/AnnouncementBoardSelector.vue';

@Component({
    components: {EnterpriseFormContainer,RecipientLookup , FastSendRecipientSelector , InPlaceMessageBox, FullPageLoader, AnnouncementBoardSelector }
})
export default class SendEnterpriseForm extends Mixins(ComponentMixinBase){
    @Prop() form?: EnterpriseForm;
    @Prop() formLblWidth?: number;
    @Prop() tableLblWidth?: number;
    @Prop() nextFormInfo?: NextFormInfo;
    shallshowLetterPreview= false;
    isNextForm = false;
    pdfLoaded = false;
    pdfSrc = {} as any;
    @Prop() letter?: Letter;
    noPdfExists = false;
    htmlSrc = "";
    viewedFileName = "";
    hasHtmlMainFile = false;
    @Prop() draftFormInfo?: DraftEnterpriseFormInfo;
    msgBoxMessage = '';
    msgBoxMessageType = '';
    msgBoxButtons = 'okCancel';
    shallShowMsgBox = false;
    formReceivers = [] as LetterOwnerWithFaxAndEmails[];
    mainReceivers = [] as LetterOwnerWithFaxAndEmails[];
    copyReceivers = [] as LetterOwnerWithFaxAndEmails[];
    draftReceivers = [] as LetterOwnerWithFaxAndEmails[];
    selectedMainRecipients = [] as LetterOwnerForSendingFaxAndEmailAndSms[];
    selectedCopyRecipients = [] as LetterOwnerForSendingFaxAndEmailAndSms[];
    selectedDraftRecipients = [] as LetterOwnerForSendingFaxAndEmailAndSms[];
    mandatoryValuesErrorMessage = "عدم تامین پارامترهای اجباری";
    announcementBoardId = '';
    sending = false;
    shallRenderOnMobile=false;
    errors = '';
    isFormSent = false;
    @Watch("form",{ immediate: true, deep: true })
    onFormChanged(){
        this.loadReceivers();
        store.state.eventHub.$emit('remove-all');
    }
    @Watch("nextFormInfo",{ immediate: true, deep: true })
    onNextFormInfoChanged(){
        store.state.eventHub.$emit('remove-all');
    }
    get showAnnouncementBoard(){
        if(!this.form) return false;
        return ( this.form.defaultAnnouncementBoardId != null && this.form.defaultAnnouncementBoardId.toString() != "00000000-0000-0000-0000-000000000000") ||
        this.form.canChangeAnnouncementBoard == true;
    }

    //  @Watch("letter")
    // onLetterChanged(newVal: Letter, oldVal: Letter){
    //     // if(this.letter){
    //     //     alert(this.letter.id);
    //     //     alert(this.letter.letterPossessionId);
    //     // }
    //    // console.log(this.letter);
       
    //     this.setPdfUrl();
        
    // }

    mounted(){
        if(this.isMobile()){
            this.shallRenderOnMobile=true
        }
        $('.pdfViewer').transition('horizontal flip in');
    }
    created(){
        this.setPdfUrl()
        store.state.eventHub.$on('show-file-requested',this.onShowFileRequested);
        this.loadReceivers();
        if(this.form){
            
            this.announcementBoardId = this.form.defaultAnnouncementBoardId;

        }
        if(this.nextFormInfo)
        {
            this.announcementBoardId = this.nextFormInfo.announcementBoardIdToSend;
        }
    }

    letterPreview(){
        this.shallshowLetterPreview=true;
        $('.pdfViewer').transition('horizontal flip in');
    }

    closePdf(){
        this.shallshowLetterPreview=false;
    }
    async onShowFileRequested(fileId: string)
    {
        const file = await fileService.getFile(fileId);
        if(file.extension.toLowerCase().includes("pdf")){
            //for pdf insert code here
            this.noPdfExists = false;
            this.pdfSrc = "data:application/pdf;base64," + file.content;
            this.viewedFileName = file.extension;
            this.hasHtmlMainFile = false;
            this.pdfLoaded = true;
        }
        else{
            
            this.noPdfExists = true;
            this.pdfSrc = "data:image/png;base64," + file.content;
            this.viewedFileName = file.extension;
            this.hasHtmlMainFile = false;
        }  
    }
    async setPdfUrl(){
         if(this.letter === undefined)return;
         this.pdfLoaded = false;
         this.noPdfExists = false;
        if(this.nextFormInfo === undefined || this.nextFormInfo === null)return;
            const file = await fileService.getFile(this.nextFormInfo.enterpriseForm.file.id);
            if(this.nextFormInfo.enterpriseForm.file.extension?.toLowerCase().includes('.html')){
                this.htmlSrc = util.b64DecodeUnicode(file.content);
                this.hasHtmlMainFile = true;
            }
            else if(this.nextFormInfo.enterpriseForm.file.extension?.toLowerCase().includes('.pdf')){
                this.pdfSrc = "data:application/pdf;base64," + file.content;
                this.pdfLoaded = true;
                this.hasHtmlMainFile = false;
            }else{
                this.noPdfExists = true;
                this.pdfSrc = "data:image/png;base64," + file.content;
                this.hasHtmlMainFile = false;
        }
    }

    returnToParent(){
        this.$emit('shallShowenterpriseFormListsEvent')
    }
    async loadReceivers(){
        
        if(!this.form)return;
        const senderId =  store.state.ownerId;
        let dependentLetterId = '';
        if(this.nextFormInfo){
            dependentLetterId = this.nextFormInfo.dependentLetterId;
        }
        this.formReceivers =  await enterpriseFormService.getFormReceivers(this.form.id,senderId,dependentLetterId,this.form.defaultAnnouncementBoardId);
        //console.log("receivers:");
        //console.log(this.formReceivers);
        this.mainReceivers = this.formReceivers.filter(x=>x.canUserSend);
        this.copyReceivers = this.formReceivers.filter(x=>x.canUserSendCopy);
        this.draftReceivers = this.formReceivers.filter(x=>x.canUserSendDraft);
        //setting defaults 
        const mainDefault =  this.mainReceivers.filter(x=>x.isSendDefault);
        mainDefault.forEach(d=>this.selectRecipient(d,'main'));
        const copyDefault =  this.copyReceivers.filter(x=>x.isSendCopyDefault);
        copyDefault.forEach(d=>this.selectRecipient(d,'copy'));
        const draftDefault =  this.draftReceivers.filter(x=>x.isSendDraftDefault);
        draftDefault.forEach(d=>this.selectRecipient(d,'draft'));

    }

    selectRecipient(recipient: LetterOwnerWithFaxAndEmails, listName: string){
        switch(listName){
            case 'main':
                this.shallShowMainLookup = false;
                break;
            case 'copy':
                this.shallShowCopyLookup = false;
                break;
            case 'draft':
                this.shallShowDraftLookup = false;
                break;
        }
        let addedItem =  this.selectedMainRecipients.find(item=>item.id === recipient.id);
        if(!addedItem) 
            addedItem = this.selectedCopyRecipients.find(item=>item.id === recipient.id);
        if(!addedItem)
            addedItem = this.selectedDraftRecipients.find(item=>item.id === recipient.id);
        if(!addedItem){
            if(listName === 'main'){
                this.selectedMainRecipients.push(letterOwnerService.getLetterOwnerForSendingFaxAndEmailAndSms(recipient));
                
            }
            else if(listName === 'copy'){
                this.selectedCopyRecipients.push(letterOwnerService.getLetterOwnerForSendingFaxAndEmailAndSms(recipient));
                
            }
            else if(listName === 'draft'){
                this.selectedDraftRecipients.push(letterOwnerService.getLetterOwnerForSendingFaxAndEmailAndSms(recipient));
                
            }
            
        }
            
    }
    onRecipientRemoved(id: string, listName: string){

        let list = [] as LetterOwnerForSendingFaxAndEmailAndSms[];
        if(listName == 'main'){
            list = this.selectedMainRecipients;
        }
        else if(listName == 'draft'){
            list = this.selectedDraftRecipients;
        }
        else if(listName == 'copy'){
            list = this.selectedCopyRecipients;
        }
        const removedItem =  list.find(item=>item.id === id);
        if(!removedItem)return;
        const index =  list.indexOf(removedItem);
        list.splice(index,1);        
    }

    onResetErrorValue(){
        this.errors='';
    }
    onErrorsExposed(errors: string){
        this.errors = errors;
        $('.popup').popup({onShow: this.shallShowError});
    }

    shallShowError(){
        $('.popup').css('max-height', $(window).height());
        return this.errors != '';
    }
    onNoErrors(){
        this.errors = '';
    }
    
    async send(mode: string){

        if(this.errors != '')return;
        if(this.selectedMainRecipients.length === 0 && this.selectedDraftRecipients.length === 0){
            this.msgBoxMessage = "هیچ گیرنده اصلی یا پیش نویس انتخاب نشده است";
            this.msgBoxMessageType = 'fail';
            this.msgBoxButtons = 'ok';
            this.shallShowMsgBox = true;
            return;
        }
        this.sending = true;
        const sendFormDto = {} as any;
        const mandatoryValidation = {allValuesSupplied: true,errors:[]} as any;
        store.state.eventHub.$emit("mandatory-values-validation",mandatoryValidation);
        if(!mandatoryValidation.allValuesSupplied)
        {
            this.errors = this.mandatoryValuesErrorMessage;
            console.log(mandatoryValidation.errors);
            $('.popup').popup({onShow: this.shallShowError});
            this.sending = false;
            return;
        }
        else{
            this.errors = '';
        }
        store.state.eventHub.$emit('send-enterpriseform',sendFormDto);
      
        //Adding attached files to dto
        const attachedFiles = [] as any[];
        store.state.eventHub.$emit('add-file-requested',attachedFiles);
        sendFormDto.attachedFiles = attachedFiles;
        
        sendFormDto.draftReceivers = this.selectedDraftRecipients;
        sendFormDto.copyReceivers  = this.selectedCopyRecipients;
        sendFormDto.Receivers = this.selectedMainRecipients;
        if(this.nextFormInfo){
            sendFormDto.dependentLetterId = this.nextFormInfo.dependentLetterId;
            this.isNextForm = true;
        }
        else{
            this.isNextForm = false;
        }
        if(this.draftFormInfo)
            sendFormDto.parentDraftId = this.draftFormInfo.draftLetterId;
        
        sendFormDto.announcementFolder = this.announcementBoardId;
        const sendingResults =  await enterpriseFormService.sendEnterpriseForm(sendFormDto,mode);
        this.sending = false;
        
        if(!sendingResults.hasError){
            this.msgBoxMessageType = 'success';
            this.msgBoxButtons = 'ok';
            if(mode === 'send'){
                
                if(sendingResults.sentLetterInformation.letterNumber != ''){
                    this.msgBoxMessage = `نامه با شماره ${sendingResults.sentLetterInformation.letterNumber} ارسال گردید.`
                    //this.shallShowMsgBox = true;
                    this.isFormSent = true;
                    store.state.eventHub.$emit("show-message",this.msgBoxMessage);
                    this.$emit('sendform-close',this.isNextForm);
                }
            }
            else{
                 this.msgBoxMessage = "پیشنویس ذخیره شد";
                 //this.shallShowMsgBox = true;
                 this.isFormSent = true;
                 store.state.eventHub.$emit("show-message",this.msgBoxMessage);
                 this.$emit('sendform-close',this.isNextForm);
            }
        }
        else{
            this.msgBoxMessageType = 'fail';
            this.msgBoxButtons = 'ok';
            this.msgBoxMessage = sendingResults.errorMessage;
            this.shallShowMsgBox = true;
            this.isFormSent = true;
            this.isNextForm = false;
        }
    }
    cancel(){
        this.isNextForm = false;
        this.msgBoxMessage = 'آیا مطمئن هستید؟';
        this.msgBoxMessageType = '';
        this.msgBoxButtons = 'yesNo';
        this.shallShowMsgBox = true;
    }
    onMsgBoxButtonClicked(btn: string){
        this.shallShowMsgBox = false;
        if((btn ==='ok' && this.isFormSent) || btn === 'yes'){
            this.$emit('sendform-close',this.isNextForm);
        }
    }
    shallShowMainLookup = false;
    shallShowCopyLookup = false;
    shallShowDraftLookup = false;
    onAddRecipientRequest(mode: string){
        switch(mode){
            case 'main':
                this.shallShowMainLookup = true;
                break;
            case 'copy':
                this.shallShowCopyLookup = true;
                break;
            case 'draft':
                this.shallShowDraftLookup = true;
                break;
        }
    }

    get getNewKey(){
        //console.log("containerKey:==>")
        const newKey = util.getNewGuid();
        //console.log(newKey);
        return newKey;
    }

    onBoardSelected(eventArg: any){
        this.announcementBoardId =  eventArg.id;
    }
}
